<button *ngIf="!isMatItem" mat-flat-button color="primary" (click)="openRescheduleDialog(meeting)">
  {{ 'MEETING_SCHEDULER.MEETING_ACTIONS.RESCHEDULE' | translate }}
</button>

<div class="reshedule-mat-menu-item" *ngIf="isMatItem" (click)="openRescheduleDialog(meeting)">
  {{ 'MEETING_SCHEDULER.MEETING_ACTIONS.RESCHEDULE' | translate }}
</div>
